import React, { useEffect, useState } from 'react';
import { List, Avatar, Modal, Form, Tooltip } from 'antd';
import { Cards } from '../../components/cards/frame/cards-frame';
import { BorderLessHeading } from '../styled';
import { Button } from '../../components/buttons/buttons';
import InboxListStyleWrap from './TaskProgressStyle';
import { useDispatch, useSelector } from 'react-redux';
import { getProgressByTaskDataRead, progressCommentDataSubmit } from '../../redux/progress/actionCreator';
import { getItem } from '../../utility/localStorageControl';
import { formatDateAndTime } from '../../components/formatDate/FormatDate';
import CustomSpinner from '../ui-elements/spinner/CustomSpinner';
import { UilCornerUpLeft } from '@iconscout/react-unicons';
import TextArea from 'antd/lib/input/TextArea';


function TaskProgress({ data }) {

    const dispatch = useDispatch();
    const [form] = Form.useForm()
    const [dataSource, setDataSource] = useState([]);
    const [addCommentModalVisible, setAddCommentModalVisible] = useState(false);
    const [addCommentRecord, setAddCommentRecord] = useState(null);

    const { isProgressCommentAddResLoading, ProgressCommentAddRes, isGetProgressByTaskResLoading, GetProgressByTaskRes } = useSelector((state) => {
        return {
            GetProgressByTaskRes: state.GetProgressByTaskRes.data,
            isGetProgressByTaskResLoading: state.GetProgressByTaskRes.loading,
            ProgressCommentAddRes: state.ProgressCommentAddRes.data,
            isProgressCommentAddResLoading: state.ProgressCommentAddRes.loading,
        };
    });


    useEffect(() => {
        if (dispatch) {
            if (data?.id !== null) {
                dispatch(getProgressByTaskDataRead(parseInt(data?.id)))
            }
        }
    }, [data])

    useEffect(() => {
        if (ProgressCommentAddRes !== null && ProgressCommentAddRes.Error === false) {
            if (data?.id !== null) {
                dispatch(getProgressByTaskDataRead(parseInt(data?.id)))
            }
        }
    }, [ProgressCommentAddRes])

    useEffect(() => {
        if (GetProgressByTaskRes && GetProgressByTaskRes?.length > 0) {
            const filteredData = GetProgressByTaskRes
                ?.slice()
                .sort((a, b) => new Date(b?.createdon) - new Date(a?.createdon))
                .map((item) => ({
                    id: item?.id,
                    key: item?.id,
                    progress: item?.progress,
                    username: item?.person?.usermaster?.username,
                    usermasterId: item?.person?.usermaster?.id,
                    name: item?.person?.name,
                    date: formatDateAndTime(item?.createdon),
                    comment: item?.comment !== null ? item?.comment : null,
                    commentflag: item?.commentflag,
                    commentedBy: item?.commentedBy !== null ? item?.commentedBy : 'NA',
                    comment_createdon: item?.comment_createdon !== null ? formatDateAndTime(item?.comment_createdon) : 'NA'
                }));
            setDataSource(filteredData);
        } else {
            setDataSource([])
        }
    }, [GetProgressByTaskRes])


    const handleAddComment = (item) => {        
        setAddCommentRecord(item)
        setAddCommentModalVisible(true);
        if (item.commentflag === true) {
            form.setFieldsValue({
                comment: item?.comment
            })
        }
    }

    const handleAddCommentModalCancel = () => {
        setAddCommentModalVisible(false);
        setAddCommentRecord(null);
        form.resetFields();
    }

    const handleSubmitComment = () => {
        form.validateFields().then((values) => {
            const payload = {
                id: addCommentRecord?.id,
                comment: values.comment,
                userId: addCommentRecord?.usermasterId,
                username: addCommentRecord?.username,
            }
            dispatch(progressCommentDataSubmit(payload))
            setAddCommentModalVisible(false);
            form.resetFields();
            setAddCommentRecord(null);
        })
            .catch((error) => {
                console.error('Error while validating form:', error);
            });
    }

    return (
        <>
            {isGetProgressByTaskResLoading || isProgressCommentAddResLoading ?
                (
                    <div className="custom-loading-spin-with-text">
                        <CustomSpinner />
                        <p style={{ fontWeight: 'bold', color: '#073886' }}>
                            Loading please wait...
                        </p>
                    </div>
                ) : (
                    <>
                        <BorderLessHeading>
                            <InboxListStyleWrap>
                                {dataSource?.length > 0 ?
                                    <List
                                        className="demo-loadmore-list"
                                        itemLayout="horizontal"
                                        dataSource={dataSource}
                                        renderItem={(item) => (
                                            <List.Item>
                                                <List.Item.Meta
                                                    avatar={
                                                        item?.username && (
                                                            <img className='img-border-radius img-dimensions' src={`${process.env.REACT_APP_API_ENDPOINT}/public/profile/${item?.username}.png`} alt={''}
                                                                onError={(e) => {
                                                                    e.target.style.display = "none";
                                                                    e.target.parentNode.appendChild(document.createElement("div")).innerHTML =
                                                                        `<span class="ant-avatar ant-avatar-circle">
                                                                        ${item?.username[0].toUpperCase()}
                                                                    </span>`;
                                                                }}
                                                            />
                                                        )
                                                    }
                                                    title={
                                                        <div className='d-flex justify-content-between'>
                                                            <span>
                                                                {item?.username === getItem('username') ? 'You' : item?.name}
                                                            </span>
                                                            <span className="ninjadash-mail-time">
                                                                {getItem('role') === 'ADMIN' &&
                                                                    <Tooltip title={item?.commentflag === true ? 'Update Comment' : 'Add Comment'}>
                                                                        <Button onClick={() => handleAddComment(item)} className='mr-10' type='primary' transparented size='medium'><UilCornerUpLeft /></Button>
                                                                    </Tooltip>
                                                                }
                                                                {item?.date}
                                                            </span>
                                                        </div>
                                                    }
                                                    description={
                                                        <div>

                                                            <div dangerouslySetInnerHTML={{
                                                                __html: item?.progress
                                                            }} />
                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                {item?.comment !== null &&
                                                                    <span><strong>Comment: </strong>{item?.comment}</span>
                                                                }
                                                                {item?.commentflag === true &&
                                                                    <span>
                                                                        <div className='d-flex'>
                                                                            <div className='mr-10'>
                                                                                <strong>Comment By: </strong>{item?.commentedBy}
                                                                            </div>
                                                                            <div>
                                                                                <strong>Comment Updated On: </strong>{item?.comment_createdon}
                                                                            </div>
                                                                        </div>
                                                                    </span>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                />
                                            </List.Item>
                                        )}
                                    />
                                    :
                                    <div className='d-flex justify-content-center'>
                                        <h4>No Progress Yet</h4>
                                    </div>
                                }
                            </InboxListStyleWrap>
                        </BorderLessHeading>
                        <Modal
                            title={<span>{addCommentRecord?.commentflag === true ? 'Update comment' : 'Add comment'} for progress update by <strong style={{ fontStyle: 'italic' }}>{addCommentRecord?.username}</strong></span>}
                            centered
                            open={addCommentModalVisible}
                            onCancel={handleAddCommentModalCancel}
                            maskClosable={false}
                            width={500}
                            footer={[
                                <Button id="submit-comment-button" key="SubmitCommentRecord" type="primary" onClick={handleSubmitComment}>
                                    {addCommentRecord?.commentflag === true ? 'Update' : 'Submit'}
                                </Button>
                            ]}
                        >
                            <Form form={form} layout='vertical'>
                                <Form.Item name='comment' label='Comment'
                                    rules={[
                                        {
                                            validator: (_, value) =>
                                                value && value.trim() !== ''
                                                    ? Promise.resolve()
                                                    : Promise.reject(new Error('Comment cannot be empty or just spaces')),
                                        },
                                    ]}
                                >
                                    <TextArea rows={3} placeholder='Enter comment' />
                                </Form.Item>
                            </Form>
                        </Modal>
                    </>
                )}
        </>
    );
}

export default TaskProgress;
